export default __webpack_public_path__ + "static/media/hero1.87cd8d98.webp";